import tmhRequest from '@/config/tmhRequest'

export default {

    searchListRateType: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/ratetype/searchlistratetype',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/baseinfo/ratetype.js